<template>
    <div class="landing-page backtop">
        <div class="backTop" v-show="btnFlag" @click="backTop">
            <img class="go-top" src="@/assets/image/landingpage/jiantou.png" />
        </div>

        <div class="landing-page-banner">
            <div class="landing-page-banner-inner">
                <div class="landing-page-banner-title">
                    爱设计企业版：一站式营销设计解决方案
                </div>
                <div class="landing-page-banner-font">
                    <p>1.新型在线设计引擎，简单高效作图，一键极速分发</p>
                    <p>
                        2.整合亿级版权素材及爱设计海量版权模版库，为企业提供多快好省的素材内容，100%规避版权⻛险
                    </p>
                    <p>3.品牌管理，品牌规范，团队协作，安全存储，灵活复用</p>
                </div>
                <div class="landing-page-banner-btn">
                    <el-button stats-mark="企业落地页-开通企业版按钮点击pv" style="width: 130px; height: 48px" @click="dialogQuestionVisible = true">开通企业版</el-button>
                    <el-button stats-mark="企业落地页-登录企业版按钮点击pv" style="width: 130px; height: 48px" class="el-button-text el-button-text--primary" @click="toCompany">{{ titile }}</el-button>
                </div>
            </div>
        </div>
        <div class="landing-page-main">
            <div class="landing-page-float-quanyi" v-if="Offline" v-show="scrollShow && priceList.length">
                <div class="landing-page-float-quanyi-inner">
                    <div class="landing-page-float-quanyi-tag">权益明细</div>
                    <div class="landing-page-float-quanyi-tag" v-for="(item, index) in priceList" :key="item.name">
                        <p class="landing-page-float-quanyi-tag-top">
                            {{ item.name
              }}<span>{{ item.price
                }}<i style="color: #2d2d32">{{ item.price_suffix }}</i></span>
                        </p>
                        <el-button type="primary" style="width: 144px; height: 40px" :disabled="item.button_status === 1" @click="openPayDialog(item)">{{ item.button_text }}</el-button>
                    </div>
                    <div class="landing-page-float-quanyi-tag">
                        <p class="landing-page-float-quanyi-tag-top">
                            企业旗舰版<span><i style="color: #2d2d32">提供定制服务</i></span>
                        </p>
                        <el-button stats-mark="企业落地页-企业旗舰版-咨询顾问按钮点击pv" type="primary" style="width: 144px; height: 40px" @click="
                openPayDialog({
                  name: '企业旗舰版',
                  tip: '咨询顾问',
                })
              ">咨询顾问</el-button>
                    </div>
                </div>
            </div>
            <section v-if='Offline' class="landing-page-main-item part1">
                <div class="landing-page-main-title">选择适合你的套餐版本</div>
                <!-- <div class="landing-page-main-subtitle">
          在此开通会员默认新开企业用户；若需为已有企业用户续费，请联系为您服务的客户经理
        </div> -->
                <div class="product-wrapper">
                    <div class="product-item" v-for="(item, index) in priceList" :key="item.name">
                        <p class="product-line center mb12">
                            <img class="product-icon" src="@/assets/image/landingpage/vip_icon.png" alt="" />
                            <span class="product-title">{{ item.name }}</span>
                        </p>
                        <p class="product-line price" style="padding-left: 45px">
                            <span>¥</span>{{ item.price
              }}<span style="color: #000">{{ item.price_suffix }}</span>
                        </p>
                        <p class="product-line cut center mb12">
                            原价 {{ item.cost_price }}
                        </p>
                        <p class="product-line weight center mb24">{{ item.desc }}</p>
                        <p class="product-line mb24">
                            <el-button type="primary" :disabled="item.button_status === 1" @click="openPayDialog(item)">
                                {{ item.button_text }}</el-button>
                        </p>
                        <!-- 产品1 -->
                        <template v-if="index === 0">
                            <p class="product-line weight mb10">适用范围：线上+线下全范围</p>
                            <p class="product-line line24">
                                5人以内设计协作团队，适用于连锁经营、个体门店、电商、新媒体、私域运营等营销场景
                            </p>
                            <p class="cut-line"></p>
                            <p class="product-line weight mb8">版权图片：50张</p>
                            <p class="product-line weight mb8">定制设计服务：1次</p>
                            <p class="product-line weight mb8">
                                品牌VI在线管理/企业成员权限管理
                            </p>
                            <p class="product-line mb8">一键抠图</p>
                            <p class="product-line mb8">PSD文件上传/自动解析</p>
                            <p class="product-line">专属客服</p>
                        </template>
                        <!-- 产品2 -->
                        <template v-if="index === 1">
                            <p class="product-line weight mb10">适用范围：线上+线下全范围</p>
                            <p class="product-line line24">
                                10人以内设计协作团队，适用于连锁经营、个体门店、电商、新媒体、私域运营等营销场景
                            </p>
                            <p class="cut-line"></p>
                            <p class="product-line weight mb8">版权图片：150张</p>
                            <p class="product-line weight mb8">定制设计服务：2次</p>
                            <p class="product-line weight mb8">
                                品牌VI在线管理/企业成员权限管理
                            </p>
                            <p class="product-line mb8">一键抠图</p>
                            <p class="product-line mb8">PSD文件上传/自动解析</p>
                            <p class="product-line">专属客服</p>
                        </template>
                    </div>
                    <div class="product-item" v-show="priceList.length">
                        <p class="product-line center mb22">
                            <img class="product-icon" src="@/assets/image/landingpage/custom-built_icon.png" alt="" />
                            <span class="product-title">企业旗舰版</span>
                        </p>
                        <p class="product-line weight strong mb48 center">提供定制服务</p>
                        <p class="product-line weight center mb24">使用人数可定制</p>
                        <p class="product-line mb24">
                            <el-button stats-mark="企业落地页-企业旗舰版-咨询顾问按钮点击pv" type="primary" @click="
                  openPayDialog({
                    name: '企业旗舰版',
                    tip: '咨询顾问',
                  })
                ">咨询顾问</el-button>
                        </p>
                        <p class="product-line weight mb10">适用范围：线上+线下全范围</p>
                        <p class="product-line line24">
                            10人以上成员众多的大型企业，适用于连锁经营、个体门店、电商、新媒体、私域运营等营销场景
                        </p>
                        <p class="cut-line"></p>
                        <p class="product-line weight mb8">版权图片数量/类型可定制</p>
                        <p class="product-line weight mb8">设计服务可定制</p>
                        <p class="product-line weight mb8">企业专属模板定制</p>
                        <p class="product-line weight mb8">
                            品牌VI在线管理/企业成员权限管理
                        </p>
                        <p class="product-line mb8">云端存储空间可定制</p>
                        <p class="product-line mb8">一键抠图</p>
                        <p class="product-line mb8">PSD文件上传/自动解析</p>
                        <p class="product-line">专属客服</p>
                    </div>
                </div>
            </section>
            <section class="landing-page-main-item part2">
                <div class="landing-page-main-title">
                    内容丰富，版权清晰，一次采购全部拥有
                </div>
                <div class="landing-page-main-inner left-flex">
                    <div class="part-list" style="margin-right: 38px">
                        <div v-for="(item, index) in partContent.part2" :key="item.title" class="part-list-item" :class="item.hover ? 'part-list-item-active' : ''" @mouseover="
                partContentHover(partContent.part2, () => {
                  $set(item, 'hover', true);
                })
              ">
                            <div class="part-list-item-title">{{ item.title }}</div>
                            <div class="part-list-item-subtitle">{{ item.subtitle }}</div>
                        </div>
                    </div>
                    <div class="part-show-wrapper">
                        <img style="width: 620px" :src="partContentObj(partContent.part2).img" alt="" />
                        <video width="100%" loop="loop" autoplay="autoplay" v-if="partContentObj(partContent.part2).video" :src="partContentObj(partContent.part2).video"></video>
                    </div>
                </div>
            </section>
            <section class="landing-page-main-item part3">
                <div class="landing-page-main-title">
                    定制设计，省心省力，产品+服务全方位保障企业营销设计需求
                </div>
                <div class="landing-page-main-inner right-flex">
                    <div class="part-show-wrapper">
                        <img style="width: 620px" :src="partContentObj(partContent.part3).img" alt="" />
                        <video width="100%" loop="loop" autoplay="autoplay" v-if="partContentObj(partContent.part3).video" :src="partContentObj(partContent.part3).video"></video>
                    </div>
                    <div class="part-list" style="margin-left: 81px">
                        <div v-for="(item, index) in partContent.part3" :key="item.title" class="part-list-item" :class="item.hover ? 'part-list-item-active' : ''" @mouseover="
                partContentHover(partContent.part3, () => {
                  $set(item, 'hover', true);
                })
              ">
                            <div class="part-list-item-title">{{ item.title }}</div>
                            <div class="part-list-item-subtitle">{{ item.subtitle }}</div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="landing-page-main-item part4">
                <div class="landing-page-main-title">
                    极简作图，极速分发，人人都是设计师
                </div>
                <div class="landing-page-main-inner left-flex">
                    <div class="part-list" style="margin-right: 81px">
                        <div v-for="(item, index) in partContent.part4" :key="item.title" class="part-list-item" :class="item.hover ? 'part-list-item-active' : ''" @mouseover="
                partContentHover(partContent.part4, () => {
                  $set(item, 'hover', true);
                })
              ">
                            <div class="part-list-item-title">{{ item.title }}</div>
                            <div class="part-list-item-subtitle">{{ item.subtitle }}</div>
                        </div>
                    </div>
                    <div class="part-show-wrapper">
                        <img style="width: 620px" :src="partContentObj(partContent.part4).img" alt="" />
                        <video width="100%" loop="loop" autoplay="autoplay" v-if="partContentObj(partContent.part4).video" :src="partContentObj(partContent.part4).video"></video>
                    </div>
                </div>
            </section>
            <section class="landing-page-main-item part5">
                <div class="landing-page-main-title">
                    品牌营销素材中心化管理，安全存储，灵活高效
                </div>
                <div class="landing-page-main-inner right-flex">
                    <div class="part-show-wrapper">
                        <img style="width: 620px" :src="partContentObj(partContent.part5).img" alt="" />
                        <video width="100%" loop="loop" autoplay="autoplay" v-if="partContentObj(partContent.part5).video" :src="partContentObj(partContent.part5).video"></video>
                    </div>
                    <div class="part-list" style="margin-left: 81px">
                        <div v-for="(item, index) in partContent.part5" :key="item.title" class="part-list-item" :class="item.hover ? 'part-list-item-active' : ''" @mouseover="
                partContentHover(partContent.part5, () => {
                  $set(item, 'hover', true);
                })
              ">
                            <div class="part-list-item-title">{{ item.title }}</div>
                            <div class="part-list-item-subtitle">{{ item.subtitle }}</div>
                        </div>
                    </div>
                </div>
                <div class="video-wrapper">
                    <video src="https://respool.isheji.com/isheji/static/pc/video/05.mp4" width="100%" height="100%" controls="controls" loop="loop"></video>
                </div>
            </section>
            <section v-if='Offline' class="landing-page-main-item part6">
                <div class="landing-page-main-title">会员权益介绍</div>
                <div class="landing-page-main-inner" style="display: initial">
                    <listvip />
                </div>
            </section>
            <section class="landing-page-main-item part7" ref="part7">
                <div class="landing-page-main-title">合作客户</div>
                <div class="landing-page-main-inner center-flex">
                    <img class="client" src="@/assets/image/landingpage/part7.png" alt="" />
                    <div class="person-wrapper">
                        <div class="person-font">
                            <img class="person-font-img" :src="currentPersonObj.font" alt="" />
                        </div>
                        <div class="person-control-list">
                            <div v-for="item in personContent" :key="item.name" class="person-control-item" :class="currentPerson === item.name ? 'active' : ''" @click="currentPerson = item.name">
                                <img class="person-control-item-img" :src="item.icon" alt="" />
                                <div class="person-control-font">
                                    <p class="person-control-item-name">{{ item.name }}</p>
                                    <p class="person-control-item-title">{{ item.title }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="landing-page-main-item part8">
                <div class="landing-page-main-title">爱设计新动态</div>
                <div class="landing-page-main-inner center-flex">
                    <div class="landing-page-article-tag" v-for="(item, index) in articleContent" :key="item.title">
                        <div class="landing-page-article-tag-top">
                            <img :src="item.icon" alt="" />
                            <div class="landing-page-article-tag-top-r">
                                <p class="landing-page-article-tag-top-r-title">
                                    {{ item.title }}
                                </p>
                                <p class="landing-page-article-tag-top-r-sub">
                                    {{ item.subtitle }}
                                </p>
                            </div>
                        </div>
                        <div class="landing-page-article-tag-bottom">
                            <div v-for="(val, i) in item.list" :key="val" class="landing-page-article-tag-bottom-title" @click="goArticle(val.url, val.name)">
                                {{ val.name }}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="landing-page-main-item part9">
                <div class="landing-page-main-title">定制你的企业营销设计解决方案</div>
                <div class="landing-page-main-subtitle">
                    爱设计团队将在一个工作日内联系您
                </div>
                <div class="landing-page-main-inner">
                    <questions />
                </div>
            </section>
            <section class="landing-page-main-item part10">
                <div class="landing-page-main-title">常见问题</div>
                <div class="landing-page-main-inner space-flex">
                    <div class="question-tag">
                        <div class="question-tag-title">
                            Q1.爱设计网站VIP是否和小程序端的VIP通用？
                        </div>
                        <div class="question-tag-content">
                            您在爱设计网站购买VIP，可以和小程序端的VIP通用。一次购买，两处特权
                        </div>
                    </div>
                    <div class="question-tag">
                        <div class="question-tag-title">Q2.如何查看我的VIP到期时间？</div>
                        <div class="question-tag-content">
                            可点击头像下拉框中的账号设置，基本信息中查看您的VIP到期时间
                        </div>
                    </div>
                    <div class="question-tag">
                        <div class="question-tag-title">Q3.购买VIP后是否可以退款？</div>
                        <div class="question-tag-content">
                            爱设计VIP服务属于虚拟产品，非故障情况，一经生效后不支付退订和退款，感谢您的谅解
                        </div>
                    </div>
                    <div class="question-tag">
                        <div class="question-tag-title">Q4.可以开发票吗？在哪里开？</div>
                        <div class="question-tag-content">
                            购买爱设计VIP会员后，您可以点击头像下拉框中的申请发票页面申请我们将在15个工作日内将电子发票形式的增值税普通发票发送至您填写的联系人邮箱内
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <!-- <contact :qrcode="qrCode" /> -->
        <!-- 问题弹窗 -->
        <div class="popUp">
            <el-dialog title="开通企业VIP" :close-on-click-modal="false" width="760px" :visible.sync="dialogQuestionVisible">
                <question @upClose="upClose" :qrcode="qrCode" />
                <div slot="footer"></div>
            </el-dialog>
        </div>

        <el-dialog class="consultation-dialog" :close-on-click-modal="false" title="咨询顾问" width="525px" :visible.sync="dialogConsultationVisible">
            <img :src="qrCode" alt="" />
            <p class="upgrade-text">微信扫码联系专属顾问进行咨询</p>
            <div slot="footer"></div>
        </el-dialog>
        <payDialog v-if="payDialogShow" :priceList="priceList" pageType="1" @close="payDialogShow = false" @showPaySuccess="dialogConsultationVisible = toArticlePage" />
        <login-dialog ref="loginInLanding" v-if="showLogin" :operateSource="loginSource" @close="showLogin = false" @openPayDialog="openPayDialog" />
    </div>
</template>

<script>
// import contact from "@/components/common/contact";
import listvip from "@/components/landing/listvip";
import question from "@/components/landing/question";
import questions from "@/components/landing/questions";
import payDialog from "@/components/common/payDialog";
import loginDialog from "@/components/common/loginDialog";
import { Landing, UserInfo } from "@/config/axios/landing.js";
import tokenFunc from "@/config/static/token";
import statistics from "@/utils/statistic/statistics";

import { mapState } from "vuex";

export default {
    name: "landing",
    data() {
        return {
            btnFla: false,
            Offline: false,
            partContent: {
                part2: [
                    {
                        title: "30W+设计师模板素材",
                        subtitle:
                            "海量自有设计师模板，覆盖全行业，节点/热点营销及办公素材一站搞定",
                        hover: true,
                        img:
                            "https://respool.isheji.com/isheji/static/mini/landingpage/partcontent/part2-1.png",
                        video: "",
                    },
                    {
                        title: "200+ 版权字体款数",
                        subtitle: "精选国内外优质常用字体，正版保障，满足企业营销设计需求",
                        hover: false,
                        img:
                            "https://respool.isheji.com/isheji/static/mini/landingpage/partcontent/part2-2.png",
                        video: "",
                    },
                    {
                        title: "视觉中国战略投资，亿级版权图片",
                        subtitle:
                            "视觉中国战略合作伙伴，亿级正版商业授权素材，商用场景全覆盖",
                        hover: false,
                        img:
                            "https://respool.isheji.com/isheji/static/mini/landingpage/partcontent/part2-3.png",
                        video: "",
                    },
                    {
                        title: "提供正规商业授权书",
                        subtitle: "授权清晰，为企业版客户提供商用授权书，规避版权风险",
                        hover: false,
                        img:
                            "https://respool.isheji.com/isheji/static/mini/landingpage/partcontent/part2-4.png",
                        video: "",
                    },
                ],
                part3: [
                    {
                        title: "定制设计",
                        subtitle:
                            "根据企业个性化需求，爱设计资深设计师提供定制设计服务，内容涵盖线上/线下多营销场景，并沉淀为企业长期可复用的品牌营销资产",
                        hover: true,
                        img:
                            "https://respool.isheji.com/isheji/static/mini/landingpage/partcontent/part3-1.png",
                        video: "",
                    },
                    {
                        title: "专属设计素材中心配置",
                        subtitle:
                            "爱设计根据企业品牌形象，为企业配置专属设计素材中心，为设计、市场、品牌、运营、人事、行政等跨部门、跨区域的成员提供规范统一、操作便捷的营销设计体验，实现高效协作",
                        hover: false,
                        img:
                            "https://respool.isheji.com/isheji/static/mini/landingpage/partcontent/part3-2.png",
                        video: "",
                    }
                ],
                part4: [
                    {
                        title: "新型设计引擎，0门槛在线作图",
                        subtitle:
                            "海量设计模板在线编辑，作图0门槛，一键抠图，免除团队排期等待困扰，及时高效",
                        hover: true,
                        img:
                            "https://respool.isheji.com/isheji/static/mini/landingpage/partcontent/part4-1.png",
                        video: "",
                    },
                    {
                        title: "营销物料 1-100 极速分发",
                        subtitle:
                            "设计师只需输出核心创意，平台自动解析PSD文件，全员一键编辑分发，适用于大型连锁经营与私域营销企业场景",
                        hover: false,
                        img:
                            "https://respool.isheji.com/isheji/static/mini/landingpage/partcontent/part4-2.png",
                        video: "https://respool.isheji.com/isheji/static/pc/video/06.mp4",
                    },
                    {
                        title: "人人都是设计师",
                        subtitle:
                            "技术驱动企业数字化办公，降本增效，让设计不再过度依赖于人工，全面打通营销设计各链路，标准化作业流程，为企业节省人工成本",
                        hover: false,
                        img:
                            "https://respool.isheji.com/isheji/static/mini/landingpage/partcontent/part4-3.png",
                        video: "",
                    },
                ],
                part5: [
                    {
                        title: "设计管理",
                        subtitle:
                            "海量企业模板/企业素材团队共享，有效规避孤岛化，盘活创意资产，减少重复购买重复设计，保障企业内容素材安全存储、随取随用、灵活复用",
                        hover: true,
                        img:
                            "https://respool.isheji.com/isheji/static/mini/landingpage/partcontent/part5-1.png",
                        video: "",
                    },
                    {
                        title: "品牌管理",
                        subtitle:
                            "企业管理者可通过设置团队协作成员的编辑、协同权限的⽅式来保证保证企业品牌资产的统⼀性与合规性",
                        hover: false,
                        img:
                            "https://respool.isheji.com/isheji/static/mini/landingpage/partcontent/part5-2.png",
                        video: "",
                    },
                ],
            },
            personContent: [
                {
                    name: "阿浪",
                    title: "新东方集团品牌设计总监",
                    icon:
                        "https://respool.isheji.com/isheji/static/mini/landingpage/person_icon1.png",
                    font:
                        "https://respool.isheji.com/isheji/static/mini/landingpage/person_font1_new.png",
                },
                {
                    name: "薛国巍",
                    title: "煲仔皇创始人",
                    icon:
                        "https://respool.isheji.com/isheji/static/mini/landingpage/person_icon2.png",
                    font:
                        "https://respool.isheji.com/isheji/static/mini/landingpage/person_font2.png",
                },
                {
                    name: "马一璇",
                    title: "墨瑟门窗CMO",
                    icon:
                        "https://respool.isheji.com/isheji/static/mini/landingpage/person_icon3.png",
                    font:
                        "https://respool.isheji.com/isheji/static/mini/landingpage/person_font3.png",
                },
                {
                    name: "段毅",
                    title: "谱时云摄影CEO",
                    icon:
                        "https://respool.isheji.com/isheji/static/mini/landingpage/person_icon4.png",
                    font:
                        "https://respool.isheji.com/isheji/static/mini/landingpage/person_font_new_4.png",
                },
            ],
            currentPerson: "阿浪",
            articleContent: [
                {
                    icon:
                        "https://respool.isheji.com/isheji/static/mini/landingpage/article_icon1.png",
                    title: "产品动态",
                    subtitle: "专注、口碑、极致",
                    list: [
                        { 
                            name: "智能文案功能",
                            url:
                                "https://dam-static.isheji.com/qiye1.0/01.jpg",
                        },
                        {
                            name: "抠图功能",
                            url:
                                "https://respool.isheji.com/isheji/2560/512104/images/20210831170113751487.png",
                        },
                        {
                            name: "企业品牌管理功能",
                            url:
                                "https://file-test.isheji.com/isheji/22/4458/images/20210928173422180510.png",
                        },
                       
                    ],
                },
                {
                    icon:
                        "https://respool.isheji.com/isheji/static/mini/landingpage/article_icon2.png",
                    title: "客户成功",
                    subtitle: "一站式营销设计解决方案",
                    list: [
                        {
                            name:
                                "爱设计专访|煲仔皇掌门人薛国巍：12年餐饮老兵，深度解析连锁餐饮数字化运营新机遇。",
                            url:
                                "https://respool.isheji.com/isheji/2560/512104/images/20210831170856509776.png",
                        },
                        {
                            name: "爱设计X新东方，教育品牌营销设计中台解决方案",
                            url:
                                "https://respool.isheji.com/isheji/2560/512104/images/20210831170836404741.png",
                        },
                        {
                            name: "爱设计×知店|营销SaaS行业如何高效实现营销设计中台的部署",
                            url:
                                "https://respool.isheji.com/isheji/2560/512104/images/20210831170431241462.png",
                        },
                    ],
                },
                {
                    icon:
                        "https://respool.isheji.com/isheji/static/mini/landingpage/article_icon3.png",
                    title: "最新活动",
                    subtitle: "iSHEJI市场动态",
                    list: [
                        {
                            name:
                                "聚焦连锁品牌营销升级，爱设计受邀出席首届“中国服务业连锁品牌发展峰会”",
                            url:
                                "https://respool.isheji.com/isheji/2560/512104/images/20210831170932534627.png",
                        },
                        {
                            name: "连锁品牌如何借助营销设计中台实现高效经营",
                            url:
                                "https://respool.isheji.com/isheji/2560/512104/images/20210831170943421787.png",
                        },
                        {
                            name: "营销设计平台「爱设计」获视觉中国千万级人民币A轮领投",
                            url:
                                "https://respool.isheji.com/isheji/2560/512104/images/20210831170955376086.png",
                        },
                    ],
                },
            ],

            scrollShow: false,
            dialogQuestionVisible: false,
            payDialogShow: false,
            priceParams: {
                vipLevel: "",
                showAll: 1,
            },
            currentProduct: null,
            priceList: [],
            dialogConsultationVisible: false,
            showLogin: false,
            token: "",
            loginSource: "",
            titile: "登录企业版",
            qrCode: "",
            btnFlag: false,
        };
    },
    computed: {
        currentPersonObj() {
            return this.personContent.find(
                (item) => item.name === this.currentPerson
            );
        },
        partContentObj() {
            return function (arr) {
                return arr.find((item) => item.hover === true);
            };
        },
        ...mapState(["loginInfo", "teamList"]),
    },
    components: {
        // contact,
        question,
        questions,
        payDialog,
        loginDialog,
        listvip,
    },
    mounted() {
        history.pushState({}, null, window.location.href);
        window.addEventListener("popstate", this.goBack, false);
        // 埋点
        statistics.init(this.$route.meta.projectPage);
        // 加载旗鱼客服
        // const oScript = document.createElement("script");
        // oScript.type = "text/javascript";
        // oScript.src =
        //     "https://qiyukf.com/script/047bb8e122330a0f0ecaec916b1eb1a7.js";
        // document.body.appendChild(oScript);

        window.addEventListener("scroll", this.pageScroll);
        this.priceParams.vipLevel =
            this.loginInfo && this.loginInfo.company_vip_level;
        this.token = tokenFunc.getToken();
        if (!this.token) {
            this.titile = "登录企业版";
            this.loginInfo = null;
            sessionStorage.clear();
            this.getVipPrice();
        } else {
            this.getUserInfo();
            this.titile = "进入企业版";
        }
        this.getVipPrice();
        this.qrCode = "//respool.isheji.com/isheji/2363/472692/images/20220217184414575501.jpeg";
        // 为给定 ID 的 user 创建请求
        /* axios
          .get(
            "https://scrm-wx.weiling.cn/api/live_code/select?corp_id=wwf23273cda80aab27&code_channel_id=1430831934975643648"
          )
          .then((res) => {
            this.qrCode = res.data.data.qr_code;
          })
          .catch((res) => {
            Vue.prototype.$message.error("客服二维码获取失败");
          }); */

        // this.$router.push({
        //   name: "PaySuccess",
        //   params: { discount: "1" },
        // });
    },
    destroyed() {
        window.removeEventListener("scroll", this.pageScroll);
        window.removeEventListener("popstate", this.goBack, false);
    },
    methods: {
        // 点击图片回到顶部方法，加计时器是为了过渡顺滑
        backTop() {
            const that = this;
            let timer = setInterval(() => {
                let ispeed = Math.floor(-that.scrollTop / 5);
                document.documentElement.scrollTop = document.body.scrollTop =
                    that.scrollTop + ispeed;
                if (that.scrollTop === 0) {
                    clearInterval(timer);
                }
            }, 16);
        },
        //监听返回键
        goBack() {
            // console.log("点击了浏览器的返回按钮");
            window.location.href = process.env.VUE_APP_BaseHref;
            history.pushState(null, null, document.URL);
        },
        getUserInfo() {
            UserInfo().then((res) => {
                if (res.status == 1) {
                    this.priceParams.vipLevel = res.data.company_vip_level;
                    this.getVipPrice();
                }
            });
        },
        upClose() {
            this.dialogQuestionVisible = false;
        },
        browseStatistics() {
            statistics.__sendEvent({
                statsMark: "企业落地页浏览",
                projectPage: this.$route.meta.projectPage,
                projectArea: "63",
                eventArea: "63",
                eventType: "2",
                eventId: "264",
                eventName: "company_vip_page_pv",
                event_functional_source_id: 1,
                // 1-url地址栏直接访问
                // 2-首页右上角点击"企业vip"进入
                // 3-未登录状态下在首页左侧点击"创建企业"进入
                // 4-已登录状态下企业中心右上角点击"企业vip"进入
            });
        },
        goArticle(url, name) {
            // let routeOne = this.$router.resolve({
            //   path: "/article",
            //   query: {
            //     url: url,
            //   },
            // });
            // window.open(routeOne.href, "_blank");
            this.$router.push({
                path: "/article",
                query: {
                    url: url,
                    name: name,
                },
            });
        },
        pageScroll() {
            document.querySelector("body").onscroll = () => {
                let scrollTop =
                    window.pageYOffset ||
                    document.documentElement.scrollTop ||
                    document.body.scrollTop;
                this.scrollTop = scrollTop;
                if (this.scrollTop > 200) {
                    this.btnFlag = true;
                } else {
                    this.btnFlag = false;
                }
                if (this.scrollTop > 4500 && this.scrollTop < this.$refs['part7'].offsetTop - 200) {
                    this.scrollShow = true;
                } else {
                    this.scrollShow = false;
                }
            }
        },
        partContentHover(arr, cb) {
            arr.forEach((item) => {
                item.hover = false;
            });
            cb && cb();
        },
        toArticlePage(index, i) {
            this.$router.push({
                name: "Article",
                params: {
                    id: `${index + 1}-${i + 1}`,
                },
            });
        },
        getVipPrice() {
            Landing.getVipPrice(this.priceParams)
                .then((res) => {
                    this.priceList = res.data;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        toCompany() {
            if (!this.token) {
                // this.showLogin = true;
                this.$router.push({ name: 'Login' })
                return;
            } else {
                if (
                    this.loginInfo.teams.length > 0 &&
                    this.loginInfo.current_team_id == 0
                ) {
                    this.$router.push({ name: "Team" });
                } else if (this.loginInfo.current_team_id != 0) {
                    window.location.href =
                        "https://" + this.loginInfo.current_team_domain;
                } else {
                    this.dialogQuestionVisible = true;
                }
            }
            //  todo 企业版
        },
        openPayDialog(item) {
            // 埋点上报
            if (item.name === "基础协作版") {
                statistics.__sendEvent({
                    statsMark: "企业落地页-基础协作版-立即开通按钮点击pv",
                    projectPage: this.$route.meta.projectPage,
                    projectArea: "63",
                    eventArea: "63",
                    eventType: "3",
                    eventId: "260",
                    eventName: "company_vip_page_buy_basics_pv",
                });
            } else if (item.name === "高级协作版") {
                statistics.__sendEvent({
                    statsMark: "企业落地页-高级协作版-立即开通按钮点击pv",
                    projectPage: this.$route.meta.projectPage,
                    projectArea: "63",
                    eventArea: "63",
                    eventType: "3",
                    eventId: "261",
                    eventName: "company_vip_page_buy_senior_pv",
                });
            }

            this.showLogin = false;
            this.currentProduct = item && item;
            if (!tokenFunc.getToken() && item.tip != "咨询顾问") {
                this.loginSource = "立即开通";
                this.showLogin = true;
                return;
            } else {
                if (tokenFunc.getToken() && item.tip != "咨询顾问") {
                    // console.log(this.currentProduct);
                    this.priceParams.vipLevel =
                        this.loginInfo && this.loginInfo.company_vip_level;
                    this.payDialogShow = true;
                } else {
                    this.dialogQuestionVisible = true;
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.backTop {
    background: #fff;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06);
    border-radius: 4px;
    border: 1px solid #e0e0e1;
    width: 42px;
    height: 42px;
    position: fixed;
    right: 60px;
    bottom: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
    .go-top {
        width: 20px;
        height: 18px;
    }
    &:hover {
        background: #f3f3f6;
    }
}
.landing-page {
    padding-top: 60px;
    background: #ffffff;

    .landing-page-banner {
        width: 100%;
        min-width: 1200px;
        height: 500px;
        margin-bottom: 60px;
        background: url("../../../../assets/image/landingpage/banner.png");
        background-size: cover;
        background-position-x: center;

        .landing-page-banner-inner {
            width: 1200px;
            height: 100%;
            margin: 0 auto;
            box-sizing: border-box;
            padding-top: 130px;
            color: #ffffff;

            .landing-page-banner-title {
                font-size: 36px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                line-height: 50px;
                margin-bottom: 20px;
            }

            .landing-page-banner-font {
                margin-bottom: 37px;

                p {
                    font-size: 16px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    line-height: 22px;
                    margin-bottom: 8px;

                    &:last-child {
                        margin-bottom: 0;
                    }
                }
            }

            .landing-page-banner-btn {
                > button {
                    margin-right: 20px;
                    margin-left: 0;
                }

                ::v-deep( .el-button-text--primary) {
                    border: 2px solid #ffffff;
                    background-color: transparent;
                    color: #ffffff;
                }
            }
        }
    }

    .landing-page-main {
        width: 100%;

        .landing-page-float-quanyi {
            width: 100%;
            height: 120px;
            background: #ffffff;
            box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.1);
            position: fixed;
            top: 60px;
            left: 0;
            z-index: 99;

            .landing-page-float-quanyi-inner {
                display: flex;
                justify-content: center;
                width: 1200px;
                height: 100%;
                margin: 0 auto;

                .landing-page-float-quanyi-tag {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    flex: 1;
                    height: 100%;
                    background: #ffffff;
                    border: 1px solid #eae8ee;
                    border-bottom: none;
                    border-left: none;
                    font-size: 20px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #2d2d32;
                    line-height: 28px;

                    &:first-child {
                        min-width: 337px;
                        border-left: 1px solid #eae8ee;
                    }

                    .landing-page-float-quanyi-tag-top {
                        margin-bottom: 12px;

                        span {
                            margin-left: 8px;
                            font-size: 20px;
                            font-family: PingFangSC-Semibold, PingFang SC;
                            font-weight: 600;
                            color: #ff3d1d;
                            line-height: 28px;
                        }
                    }
                }
            }
        }

        section.landing-page-main-item {
            width: 1200px;
            min-width: 1200px;
            margin: 0 auto;
            box-sizing: border-box;

            .landing-page-main-title,
            .landing-page-main-subtitle {
                text-align: center;
            }

            .landing-page-main-title {
                font-size: 32px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #2d2d32;
                line-height: 50px;
            }

            .landing-page-main-subtitle {
                font-size: 16px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #2d2d32;
                line-height: 22px;
                margin-top: 10px;
            }

            .product-wrapper {
                display: flex;
                justify-content: center;
                margin-top: 48px;

                .product-item {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    width: 300px;
                    height: 724px;
                    background: url("../../../../assets/image/landingpage/product_bg.png");
                    background-size: 100%;
                    box-sizing: border-box;
                    padding: 32px 22px 0;
                    border-radius: 8px;
                    transition: all 0.5s;

                    &:nth-child(2) {
                        margin: 0 26px;
                    }

                    &:hover {
                        transform: translateY(-12px);
                        transition: all 0.3s;
                        box-shadow: 0 14px 20px 0 rgba(0, 0, 0, 0.1);
                    }

                    .product-line {
                        width: 100%;
                        font-size: 16px;
                        font-weight: 400;
                        font-family: PingFangSC-Regular, PingFang SC;
                        color: #6e6c76;
                        line-height: 22px;
                        box-sizing: border-box;

                        .product-icon {
                            width: 26px;
                            margin-right: 8px;
                        }

                        .product-title {
                            font-size: 24px;
                            font-family: PingFangSC-Medium, PingFang SC;
                            font-weight: 500;
                            color: #2d2d32;
                            line-height: 33px;
                        }

                        button {
                            width: 256px;
                        }

                        &.center {
                            display: flex;
                            justify-content: center;
                            align-items: center;
                        }

                        &.price {
                            font-size: 42px;
                            font-family: PingFangSC-Semibold, PingFang SC;
                            font-weight: 600;
                            color: #ff3d1d;
                            line-height: 59px;

                            span {
                                font-size: 16px;
                            }
                        }

                        &.cut {
                            text-decoration: line-through;
                            color: #9e9da7;
                        }

                        &.weight {
                            font-family: PingFangSC-Medium, PingFang SC;
                            font-weight: 500;
                            color: #2d2d32;
                        }

                        &.strong {
                            font-size: 32px;
                            line-height: 45px;
                        }

                        &.line22 {
                            line-height: 22px;
                        }

                        &.line24 {
                            line-height: 24px;
                        }

                        &.mb8 {
                            margin-bottom: 8px;
                        }

                        &.mb10 {
                            margin-bottom: 10px;
                        }

                        &.mb12 {
                            margin-bottom: 12px;
                        }

                        &.mb22 {
                            margin-bottom: 22px;
                        }

                        &.mb24 {
                            margin-bottom: 24px;
                        }

                        &.mb48 {
                            margin-bottom: 48px;
                        }
                    }

                    .cut-line {
                        width: 100%;
                        border-bottom: 1px dashed #e0e0e1;
                        margin: 24px 0 23px;
                    }
                }
            }

            .landing-page-main-inner {
                position: relative;
                width: 100%;
                display: flex;

                &.right-flex {
                    justify-content: right;

                    .part-list-item-active {
                        &::before {
                            right: 0;
                            background: url("../../../../assets/image/landingpage/active_tag_right.png");
                            background-size: 100%;
                        }
                    }
                }

                &.left-flex {
                    justify-content: left;

                    .part-list-item-active {
                        &::before {
                            left: 0;
                            background: url("../../../../assets/image/landingpage/active_tag_left.png");
                            background-size: 100%;
                        }
                    }
                }

                &.center-flex {
                    justify-content: center;
                    align-items: center;
                }

                &.space-flex {
                    justify-content: space-between;
                    flex-wrap: wrap;
                }

                .part-list {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;

                    .part-list-item {
                        position: relative;
                        height: 110px;
                        width: 500px;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        box-sizing: border-box;
                        padding: 0 14px 0 30px;
                        cursor: pointer;

                        &.part-list-item-active {
                            transform-style: preserve-3d;

                            &::before {
                                content: "";
                                position: absolute;
                                top: 0;
                                width: 510px;
                                height: 110px;
                                transform: translateZ(-1px);
                            }

                            .part-list-item-title {
                                color: #5a2df5;
                            }
                        }

                        .part-list-item-title {
                            font-size: 20px;
                            font-family: PingFangSC-Medium, PingFang SC;
                            font-weight: 500;
                            color: #2d2d32;
                            line-height: 28px;
                            margin-bottom: 6px;
                        }

                        .part-list-item-subtitle {
                            font-size: 14px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #6e6c76;
                            line-height: 20px;
                        }
                    }
                }

                .part-show-wrapper {
                    display: flex;
                    align-items: center;
                    position: relative;
                    width: 620px;

                    video {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -40%);
                    }
                }
            }

            &.part1 {
                height: 854px;
                margin-bottom: 88px;

                .landing-page-main-title {
                    margin-bottom: 10px;
                }
            }

            &.part2 {
                margin-bottom: 115px;

                .landing-page-main-title {
                    margin-bottom: 74px;
                }
            }

            &.part3 {
                margin-bottom: 89px;

                .landing-page-main-title {
                    margin-bottom: 49px;
                }
            }

            &.part4 {
                margin-bottom: 89px;

                .landing-page-main-title {
                    margin-bottom: 49px;
                }
            }

            &.part5 {
                margin-bottom: 89px;

                .landing-page-main-title {
                    margin-bottom: 49px;
                }

                .video-wrapper {
                    width: 712px;
                    height: 470px;
                    box-sizing: border-box;
                    padding-top: 39px;
                    margin: 88px auto 0;
                    background-image: url("../../../../assets/image/landingpage/video_bg.png");
                    background-size: 100%;
                }
            }

            &.part6 {
                margin-bottom: 89px;

                .landing-page-main-title {
                    margin-bottom: 49px;
                }

                .landing-page-main-inner {
                    img.quanyi {
                        width: 100%;
                    }
                }
            }

            &.part7 {
                margin-bottom: 158px;

                .landing-page-main-title {
                    margin-bottom: 50px;
                }

                .landing-page-main-inner {
                    flex-direction: column;

                    img.client {
                        width: 100%;
                        margin-bottom: 76px;
                    }

                    .person-wrapper {
                        width: 640px;

                        .person-font {
                            width: 100%;
                            height: 160px;
                            margin-bottom: 30px;

                            .person-font-img {
                                width: 100%;
                            }
                        }

                        .person-control-list {
                            width: 100%;
                            display: flex;
                            justify-content: center;

                            .person-control-item {
                                position: relative;
                                width: 40px;
                                height: 40px;
                                margin: 0 7px;
                                cursor: pointer;

                                &:first-child {
                                    margin-left: 0 !important;
                                }

                                &:last-child {
                                    margin-right: 0 !important;
                                }

                                &:hover {
                                    .person-control-item-img {
                                        opacity: 1;
                                    }
                                }

                                &.active {
                                    margin: 0 14px;

                                    .person-control-item-img {
                                        top: 50%;
                                        left: 50%;
                                        transform: translate(-50%, -50%);
                                        width: 64px;
                                        opacity: 1;
                                    }

                                    .person-control-font {
                                        display: block;
                                    }
                                }

                                .person-control-item-img {
                                    position: absolute;
                                    width: 100%;
                                    opacity: 0.5;
                                }

                                .person-control-font {
                                    display: none;
                                    position: absolute;
                                    top: 64px;
                                    left: 50%;
                                    transform: translateX(-50%);
                                    white-space: nowrap;
                                    text-align: center;

                                    .person-control-item-name {
                                        font-size: 16px;
                                        font-family: PingFangSC-Medium,
                                            PingFang SC;
                                        font-weight: 500;
                                        color: #2d2d32;
                                        line-height: 22px;
                                        margin-bottom: 2px;
                                    }

                                    .person-control-item-title {
                                        font-size: 14px;
                                        font-family: PingFangSC-Regular,
                                            PingFang SC;
                                        font-weight: 400;
                                        color: #9e9da7;
                                        line-height: 20px;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            &.part8 {
                width: 100%;
                padding: 60px 0;
                margin-bottom: 90px;
                background: #f5f5f8;

                .landing-page-main-title {
                    margin-bottom: 40px;
                    transform-style: preserve-3d;
                }

                .landing-page-main-inner {
                    width: 100%;

                    .landing-page-article-tag {
                        width: 372px;
                        height: 254px;
                        box-sizing: border-box;
                        padding: 30px;
                        background: #ffffff;

                        &:nth-child(2) {
                            margin: 0 42px;
                        }

                        .landing-page-article-tag-top {
                            display: flex;
                            align-items: center;
                            width: 100%;
                            padding-bottom: 20px;
                            margin-bottom: 19px;
                            border-bottom: 1px dashed #e4e2eb;

                            img {
                                width: 68px;
                                margin-right: 12px;
                            }

                            .landing-page-article-tag-top-r {
                                flex: 1;
                                display: flex;
                                flex-direction: column;
                                justify-content: center;

                                .landing-page-article-tag-top-r-title {
                                    font-size: 20px;
                                    font-family: PingFangSC-Medium, PingFang SC;
                                    font-weight: 500;
                                    color: #2d2d32;
                                    line-height: 28px;
                                    margin-bottom: 4px;
                                }

                                .landing-page-article-tag-top-r-sub {
                                    font-size: 14px;
                                    font-family: PingFangSC-Regular, PingFang SC;
                                    font-weight: 400;
                                    color: #6e6c76;
                                    line-height: 20px;
                                }
                            }
                        }

                        .landing-page-article-tag-bottom {
                            width: 100%;

                            .landing-page-article-tag-bottom-title {
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                width: 100%;
                                font-size: 16px;
                                font-family: PingFangSC-Regular, PingFang SC;
                                font-weight: 400;
                                color: #2d2d32;
                                line-height: 22px;
                                margin-bottom: 10px;
                                cursor: pointer;

                                &:last-child {
                                    margin-bottom: 0;
                                }
                            }
                        }
                    }
                }
            }

            &.part9 {
                margin-bottom: 90px;

                .landing-page-main-subtitle {
                    margin-bottom: 50px;
                }
            }

            &.part10 {
                padding-bottom: 60px;

                .landing-page-main-title {
                    margin-bottom: 50px;
                }

                .landing-page-main-inner {
                    .question-tag {
                        width: 480px;

                        &:first-child,
                        &:nth-child(2) {
                            margin-bottom: 40px;
                        }

                        .question-tag-title {
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #2d2d32;
                            font-size: 18px;
                            margin-bottom: 18px;
                        }

                        .question-tag-content {
                            font-size: 16px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #999999;
                            line-height: 22px;
                        }
                    }
                }
            }
        }
    }

    .consultation-dialog {
        ::v-deep( .el-dialog) {
            top: 50%;
            transform: translateY(-50%);
            margin-top: 0 !important;
        }

        ::v-deep( .el-dialog__header) {
            padding: 40px 0 0 0;
            width: 100%;
            height: 84px;
            box-sizing: border-box;
            text-align: center;
        }

        img {
            display: block;
            width: 164px;
            height: 164px;
            background: #aaaab1;
            margin: 24px auto 48px;
        }

        .upgrade-text {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #3c3c43;
            line-height: 20px;
            text-align: center;
        }
    }
}
.popUp {
    ::v-deep( .el-dialog .el-dialog__body) {
        padding: 0 30px;
    }
    ::v-deep( .el-dialog__header) {
        padding: 20px;
        text-align: left;
    }
    ::v-deep( .el-dialog__title) {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #3b3946;
        padding-left: 10px;
    }
}
</style>
